export default __webpack_public_path__ + "static/media/icon_adding_marker.aeb1d363.png";